import React, { useEffect, useMemo, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { FaCircleXmark } from "react-icons/fa6";
import BeatLoader from "react-spinners/BeatLoader";
import { Button, Input, UploadButton } from "../CustomComponents";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";
import Toast, { ErrorToast, SuccessToast } from "../../Hooks/useToast";
import {
  useAddClassMutation,
  useGetAllBatchesQuery,
  useUpdateClassMutation,
} from "../../Data/services/trainingApi";
import _ from "lodash";
import SelectFieldComponent from "../CustomComponents/SelectFieldComponent";
import { useUploadImageS3Mutation } from "../../Data/services/profileRequestApi";

const AddUpdateEventModal = ({ handleClose, data, refetch }) => {
  const { handleSubmit, control, setValue, watch } = useForm({});
  const [updateClass, { isLoading: addloading }] = useUpdateClassMutation();
  const [addClass, { isLoading: editLoading }] = useAddClassMutation();
  const loading = addloading || editLoading;
  const isMultileFileUpload = useMemo(() => false, []);
  const fileAcceptParams = useMemo(() => "image/png, image/jpeg", []);
  const cover_image_url = watch("cover_image_url");
  const [file, setFile] = useState(null);
  const [imageFiles, setImageFiles] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [S3Img, setS3Image] = useState(null);

  const { data: batches } = useGetAllBatchesQuery({
    search: "",
    limit: 1000,
    page: 1,
  });
  const [UploadImageS3, { isLoading: uploading }] = useUploadImageS3Mutation();

  const statusList =
    (batches?.data &&
      batches?.data?.map((x) => {
        return { label: x.name, value: x.id };
      })) ||
    [];

  const handleAddfilesAndSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFile(file);
      const doc = URL.createObjectURL(file);
      setImageFiles([...imageFiles, doc]);
    }
  };

  useEffect(() => {
    if (data) {
      for (let key in data) {
        setValue(key, data[key]);
      }
      setValue('cover_image_url', data.image_url)
    }
  }, [data]);

  const handleFileChange = async (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);

    const fileExtension = selectedFile?.name.split(".").pop();
    const payload = {
      file_name: `user/${Date.now()}.${fileExtension}`,
      content_type: selectedFile?.type,
    };

    try {
      const result = await UploadImageS3({ params: payload }).unwrap();
      setS3Image(result?.data?.presignedUrl); // This is your pre-signed PUT URL
    } catch (e) {
      ErrorToast(e.data?.message || "Upload failed");
    }
  };

  const handleImageS3Submit = async () => {
    if (S3Img && file) {
      try {
        const uploadResponse = await fetch(S3Img, {
          method: "PUT",
          headers: {
            "Content-Type": file.type,
          },
          body: file,
        });

        if (uploadResponse.ok) {
          console.log("Upload successful!");
          return true;
        } else {
          console.error("Upload failed.");
          return false;
        }
      } catch (error) {
        console.error("Upload error:", error);
        return false;
      }
    }
    return false;
  };

  const OnSubmit = async (record) => {
    console.log("calling ...")
    if (!file) {
      delete record["image_url"];
    }

    if (file && S3Img) {
      const uploadSuccess = await handleImageS3Submit();
      if (!uploadSuccess) {
        ErrorToast("Image upload failed");
        return;
      }

      const uploadedFileUrl =
        S3Img.split("?")[0] || "https://picsum.photos/200/300";
      record["image_url"] = uploadedFileUrl;
      console.log(uploadedFileUrl);
    }


    try {
      const payload = {
        slug: data?.id,
        data: { ...record, image_url: record["image_url"], latitude: 50, longitude: 50},
      };

      let response;
      if (data?.id) {
        response = await updateClass(payload);
      } else {
        response = await addClass(payload);
      }

      if (response?.error?.status === 400) {
        console.log(response?.error?.data?.message);
        ErrorToast(response?.error?.data?.message, "error");
      }

      if (response?.error?.status === 500) {
        ErrorToast(response?.error?.data?.message, "error");
      }

      if (response?.data) {
        SuccessToast(response?.data?.message);
        handleClose();
        refetch();
      }
    } catch (error) {
      console.log(error);
      if (error?.response && error?.response?.data?.message) {
        Toast(error?.response?.data?.message, "error");
      }
    }
  };

  return (
    <ModalContainer handleClose={handleClose}>
      <div className={cssStyles.modalContainer}>
        <div className="d-flex align-items-center w-100 justify-content-between mb-4">
          <p className="fs-4 fw-semibold m-0 black-text">
            {data ? "Update" : "Add"} Classes
          </p>
          <span className="bg-white bg-opacity-75 d-flex p-3 rounded-5">
            <FaCircleXmark
              role="button"
              onClick={handleClose}
              style={{ cursor: "pointer" }}
            />
          </span>
        </div>

        <Form 
        // onSubmit={handleSubmit(OnSubmit)}
        >
          <Row>
            <Col sm={12}>
              <UploadButton
                label="Upload Cover"
                classes="mb-2"
                labelClasses="p-5"
                isMultileFileUpload={isMultileFileUpload}
                fileAcceptParams={fileAcceptParams}
                file={file || cover_image_url}
                handleFileChange={handleFileChange}
              />
            </Col>
            {[
              "title",
              "event_name",
              "location",
              "start_at",
              "host_name",
              "host_designation",
              "host_experience",
              "meeting_link",
            ].map((field) => (
              <Col
                md={field === "description" ? 12 : 6}
                key={field}
                className="mb-3"
              >
                <p className="m-0 black-text text-capitalize">
                  {field.replaceAll("_", " ")}
                </p>
                <Controller
                  control={control}
                  name={field}
                  rules={{
                    required: `${field.replaceAll("_", " ")} is required`,
                  }}
                  render={({ field: { onChange, onBlur, value, ref } }) => (
                    <Input
                      type={
                        field === "start_at"
                          ? "datetime-local"
                          : field.includes("latitude") ||
                            field.includes("longitude") ||
                            field.includes("experience")
                          ? "number"
                          : "text"
                      }
                      value={value}
                      onChange={onChange}
                      innerRef={ref}
                    />
                  )}
                />
              </Col>
            ))}
            <Col md={12}>
              <p className="m-0 black-text">Category</p>
              <Controller
                control={control}
                name="batch_id"
                rules={{}}
                defaultValue={selectedStatus}
                render={({ field: { onChange, onBlur, value, ref } }) => (
                  <SelectFieldComponent
                    firstOption={
                      _.isEmpty(selectedStatus)
                        ? "Select Batch"
                        : selectedStatus
                    }
                    optionsList={statusList}
                    onSelectChange={(newValue) => {
                      onChange(newValue);
                      setSelectedStatus(newValue);
                    }}
                  />
                )}
              />
            </Col>
            <Col md={12}>
              <p className="m-0 black-text mt-3">Description</p>
              <Controller
                control={control}
                name="description"
                // defaultValue={subscriptionDescription}
                render={({ field: { onChange, onBlur, value, ref } }) => (
                  <Input
                    type="text"
                    value={value}
                    onChange={(e) => {
                      onChange(e);
                    }}
                    innerRef={ref}
                    as="textarea"
                    placeholder="Description"
                    rows={4}
                  />
                )}
              />
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <Button
                classes={`${cssStyles.cardBtn} mt-3 ${
                  loading ? "bg-white-subtle" : ""
                }`}
                text={
                  loading ? <BeatLoader size={10} /> : data ? "Update" : "Add"
                }
                // type="Submit"
                onClick={handleSubmit(OnSubmit)}
              />
            </Col>
          </Row>
        </Form>
      </div>
    </ModalContainer>
  );
};

export default AddUpdateEventModal;
